import { useEffect } from "react";
import { useAuth } from "@/shared/model/authContext";
import { useCurrentTenant, usePublicTenantBranding } from "@/entities/session/model/useSessionTenants";
import { toPublicTenantConfig, toTenantConfig } from "@/entities/session/model/tenantBranding";
import { setTenant } from "@/shared/config/tenant";
import { applyBrandTheme } from "@/shared/lib/color/brandTheme";
import { useTenantRouting } from "@/shared/lib/router/tenantPath";

/**
 * Cores, logo, idioma e moeda da organização da sessão. Sem sessão, a marca pública do slug da
 * URL (`/<slug>/login`); sem slug, ou com um slug desconhecido, a da 7Days.
 */
export function useTenantBranding(): void {
    const { isAuthenticated, loading } = useAuth();
    const { slug } = useTenantRouting();
    const { data: tenant } = useCurrentTenant(isAuthenticated);
    const { data: publicTenant } = usePublicTenantBranding(slug, !loading && !isAuthenticated);

    useEffect(() => {
        // Enquanto a sessão é restaurada, isAuthenticated é false sem querer dizer "sem sessão".
        if (loading) return;
        if (!isAuthenticated) {
            setTenant(publicTenant ? toPublicTenantConfig(publicTenant) : {});
            applyBrandTheme(publicTenant?.brandColor ?? null);
            return;
        }
        if (!tenant) return;
        setTenant(toTenantConfig(tenant));
        applyBrandTheme(tenant.brandColor);
    }, [loading, isAuthenticated, tenant, publicTenant]);
}
